/**
 * The cards sit stacked on a settings page, so their empty states are shorter
 * than EmptyState's 320px default, which suits a full-page list.
 */
export const API_ACCESS_EMPTY_MIN_HEIGHT = '160px'

/** The API Access tab's card headings, beyond the tokens card. */
export const API_ACCESS_CARDS = {
  quickStart: {
    title: 'Using Your Token',
    subtitle:
      'Send the token as a Bearer token to the base URL below. Try this request first.',
  },
} as const

/** The Website Plugin builder's card headings, shared by the cards and their skeleton. */
export const WEBSITE_PLUGIN_CARDS = {
  settings: {
    title: 'Plugin Settings',
    subtitle:
      'Nothing here is saved. Your choices are written into the embed code below.',
  },
  preview: {
    title: 'Preview',
    subtitle: 'The plugin as it will look with the selected key and settings.',
  },
  embed: {
    title: 'Embed Code',
    subtitle:
      'Your settings travel in this code (a few need the Script version). Copy it again after changing them.',
  },
} as const

/** Width of the settings column beside the preview. */
export const PLUGIN_SETTINGS_COLUMN_WIDTH = 380

/** Below this width the settings column stacks above the preview. */
export const PLUGIN_BUILDER_STACK_BELOW = 1024

/** The preview iframe's height. */
export const PLUGIN_PREVIEW_HEIGHT = 720

/** How long the preview waits for typing to settle before reloading. */
export const PLUGIN_PREVIEW_DEBOUNCE_MS = 500

/** What the preview shows instead of the plugin when it can't build a link. */
export const PLUGIN_PREVIEW_MESSAGES = {
  noKey: {
    title: 'Create A Key First',
    subtitle: 'The preview appears once you create a Website Plugin key above.',
  },
  noId: {
    title: 'Enter An ID',
    subtitle:
      'Add the ID of what the plugin should show in the Embed settings.',
  },
  invalidId: {
    title: 'Enter A Valid ID',
    subtitle:
      'Fix the ID in the Embed settings: letters, numbers, - and _ only.',
  },
  badOrigin: {
    title: 'Check The Plugin URL',
    subtitle: 'Enter a full address starting with http:// or https://.',
  },
  tooLarge: {
    title: 'Too Many Settings To Preview',
    subtitle:
      'The settings are too long for a preview link. The embed code still carries them.',
  },
} as const

/** Stands in for the preview and embed code when the keys failed to load. */
export const PLUGIN_KEYS_FAILED_MESSAGE = {
  title: 'Keys Could Not Load',
  subtitle:
    'The preview and embed code need a key. Reload the page to try again.',
} as const
